import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes, clientRequestStatus, syncStatus} from '../../util/uiconstants';
import {isEmpty} from 'lodash';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function clientRequestDetailReducer(state = initialState.clientRequestDetail, action) {
	switch (action.type) {
		case types.GET_CLIENT_REQUEST_BY_ID: {
			return action.response;
		}
		case types.UPDATE_CLIENT_REQUEST_DETAIL:
			let newState = _.cloneDeep(state);

			if (newState && action.data.response.clientRequestId === newState.clientRequestID) {
				if (action.data.response.clientUserId) {
					newState.externalAssignment.clientUserID = action.data.response.clientUserId;
				} else if (action.data.response.clientGroupId) {
					//Reassign to a group
					newState.externalAssignment.clientUserID = null;
				}
				if (action.data.response.clientGroupId)
					newState.externalAssignment.clientGroupID = action.data.response.clientGroupId;
				if (action.data.response.clientGroupName)
					newState.externalAssignment.clientGroupName = newState.assignedToGroup = action.data.response.clientGroupName;
				if (action.data.response.firstName && action.data.response.lastName) {
					newState.externalAssignment.clientUserFirstName = action.data.response.firstName;
					newState.externalAssignment.clientUserLastName = action.data.response.lastName;
					newState.externalAssignment.userDisplayName =
						action.data.response.firstName + ' ' + action.data.response.lastName;
					newState.assignedTo = action.data.response.firstName[0] + '. ' + action.data.response.lastName;
					newState.externalAssignment.clientUserInitials = action.data.response.initials;
				} else {
					newState.externalAssignment.clientUserFirstName = '';
					newState.externalAssignment.clientUserLastName = '';
					newState.externalAssignment.userDisplayName = newState.assignedTo = action.data.response?.clientGroupName;
				}
			}

			return newState;
		case types.UPDATE_IS_VALID_ASSIGNTO:
			let newState1 = _.cloneDeep(state);
			newState1.externalAssignment.isRequiredAssignedTo = action.data.response;
			return newState1;
		case types.UPDATE_SHOW_ASSIGNED_TO_EMPTY_ERROR:
			let newState2 = _.cloneDeep(state);
			newState2.externalAssignment.showAssignedToEmptyError = action.data.response;
			return newState2;

		case types.ASSOCIATE_CLIENT_REQUEST_TAG: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				if (!isEmpty(state)) {
					return {
						...state,
						tagsReadModel: [
							...state?.tagsReadModel,
							{
								engagementTagName: action?.tagData?.tagName,
								colorCode: action?.tagData?.tagColor,
								engagementTagID: action?.data?.tagId
							}
						],
						silentRefresh: true
					};
				}

				return state;
			}

			return state;
		}

		case types.UNASSOCIATE_CLIENT_REQUEST_TAG: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				if (!isEmpty(state)) {
					return {
						...state,
						tagsReadModel: [...state?.tagsReadModel?.filter((x) => x.engagementTagID !== action?.data?.tagId)],
						silentRefresh: true
					};
				}

				return state;
			}

			return state;
		}

		case types.DELETE_CLIENT_REQUEST_TAG: {
			if (action.responseObj?.status === HttpStatusCodes.NoContent) {
				let filteredTags = state.tagsReadModel?.filter((tag) => tag.engagementTagID !== action.tagId);
				return {
					...state,
					tagsReadModel: filteredTags,
					silentRefresh: true
				};
			}
			return state;
		}
		case types.REASSIGN_REQUEST_BULK:
		case types.REASSIGN_REQUEST: {
			if (!isEmpty(state)) {
				let presentState = _.cloneDeep(state);
				if (
					presentState.clientRequestStatusID == clientRequestStatus.InvalidClientContact ||
					presentState.clientRequestStatusID == clientRequestStatus.Withdrawn ||
					presentState.clientRequestStatusID == clientRequestStatus.NoClientContact
				) {
					presentState.clientRequestStatusID = clientRequestStatus.Draft;
				}
				return presentState;
			}
			return state;
		}
		case types.PATCH_CLIENT_REQUEST_FIELDS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const updatedState = _.cloneDeep(state);
				action?.meta?.data.map((item) => {
					if (item?.path) {
						const parts = item.path.split('/');
						const clientRequestId = parts.length > 1 ? parts[1] : null;
						const field = parts.length > 2 ? parts[2] : null; // RequestTitle or RequestDescription
						const value = item.value;
						if (
							clientRequestId &&
							!isNaN(clientRequestId) &&
							value &&
							updatedState.clientRequestID == parseInt(clientRequestId)
						) {
							if (field === 'RequestTitle') {
								updatedState.requestTitle = value;
							} else if (field === 'RequestDescription') {
								updatedState.requestDescription = value;
							}
						}
					}
				});
				return updatedState;
			}
			return state;
		}
		case types.UPDATE_REQUEST_DETAIL_DUE_DATE: {
			let presentState = _.cloneDeep(state);
			if (action?.data.requestId === presentState.clientRequestID) {
				presentState.dueDate = action.data.dueDate;
				return presentState;
			}
			return state;
		}
		case types.CREATE_CLIENT_REQUEST_RELATED_TASK: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				let presentState = _.cloneDeep(state);
				if (action?.response) {
					if (action?.meta?.clientRequestId === presentState.clientRequestID) {
						presentState?.relatedTasks?.push(action.response);
						presentState.silentRefresh = true;
					}
					return presentState;
				}
			}
			return state;
		}
		case types.DELETE_CLIENT_REQUEST_RELATED_TASK: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				let presentState = _.cloneDeep(state);
				if (action.meta?.relatedTaskId && presentState.clientRequestID === action.meta?.clientRequestId) {
					const relatedTaskIndex = presentState?.relatedTasks?.findIndex(
						(relatedTask) => relatedTask.taskId === action.meta?.relatedTaskId
					);
					if (relatedTaskIndex > -1) {
						presentState.relatedTasks.splice(relatedTaskIndex, 1);
						presentState.silentRefresh = true;
					}
					return presentState;
				}
			}
			return state;
		}
		case types.ADD_EY_CONTACT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				var requestStatusIdForNOtSynchronized = [
					clientRequestStatus.Draft,
					clientRequestStatus.NoClientContact,
					clientRequestStatus.InvalidClientContact
				];
				var syncStatusID = requestStatusIdForNOtSynchronized.includes(action?.clientRequestStatusId)
					? syncStatus.notSynchronized
					: syncStatus.syncInTransit;

				let presentState = _.cloneDeep(state);
				const ifExist = presentState?.followers?.find(
					(contacts) =>
						contacts.followedByUserId === action.contactUserId &&
						action?.clientRequestId == presentState?.clientRequestID
				);

				if (ifExist && ifExist.isRetry) {
					// handling if isRetry is true.
					let followers = presentState?.followers?.map((c) => {
						if (c.followedByUserId === ifExist.followedByUserId) {
							c.isRetry = false;
						}
						return c;
					});
					return {
						...presentState,
						followers: followers
					};
				}
				if (action?.response && action?.clientRequestId == presentState?.clientRequestID && presentState?.followers) {
					var followersObjectStructure = {
						clientRequestFollowedByID: action.response.id,
						clientRequestId: action?.clientRequestId,
						createDate: '',
						firstName: null,
						followedByUserId: action.response.followedByUserId,
						isRetry: false,
						isViewed: false,
						lastName: null,
						modifyDate: null,
						syncStatusId: syncStatusID,
						versionNumber: 2
					};
					let objectCopy = {
						...state,
						followers: [...state.followers, followersObjectStructure]
					};
					return objectCopy;
				}
			}
			return state;
		}
		case types.DELETE_EY_CONTACT: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				let presentState = _.cloneDeep(state);
				const deleteEyContacts = presentState?.followers?.findIndex(
					(contacts) =>
						contacts.followedByUserId === action.contactUserId &&
						action?.clientRequestId == presentState?.clientRequestID
				);
				if (deleteEyContacts > -1) {
					presentState.followers.splice(deleteEyContacts, 1);
				}
				return presentState;
			}
			return state;
		}
		case types.UPDATE_REQUEST_DETAIL_TIMEPHASE: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				let presentState = _.cloneDeep(state);
				action?.meta?.data.map((item) => {
					if (item?.path) {
						const parts = item.path.split('/');
						const clientRequestId = parts.length > 1 ? parts[1] : null;
						const field = parts.length > 2 ? parts[2] : null; // DueDate or TimePhaseId
						const value = item.value;
						if (
							clientRequestId &&
							!isNaN(clientRequestId) &&
							value &&
							presentState.clientRequestID == parseInt(clientRequestId)
						) {
							presentState.timePhaseDetails.periodName = action?.meta?.periodName;
							if (field === 'DueDate') {
								presentState.dueDate = value;
								presentState.timePhaseDetails.dueDate = value;
							} else if (field === 'TimePhaseId') {
								presentState.timePhaseDetails.timephaseID = value;
							}
						}
					}
				});
				return presentState;
			}
			return state;
		}
		case types.DELETE_CLIENT_REQUEST: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {};
			}
			return state;
		}
		case types.PATCH_CLIENT_REQUEST_PRIORITY_TYPE: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const updatedState = _.cloneDeep(state);
				action?.meta?.data.map((item) => {
					if (item?.path) {
						const parts = item.path.split('/');
						const clientRequestId = parts.length > 1 ? parts[1] : null;
						const field = parts.length > 2 ? parts[2] : null; // PriorityTypeID
						const value = item.value;
						if (
							clientRequestId &&
							!isNaN(clientRequestId) &&
							value &&
							updatedState.clientRequestID == parseInt(clientRequestId)
						) {
							if (field === 'PriorityTypeId') {
								updatedState.priorityTypeID = value;
							}
						}
					}
				});
				return updatedState;
			}
			return state;
		}
		default:
			return state;
	}
}
